import { Route, Switch } from 'react-router-dom';
import GroupEmergencyResponseTeam from './GroupEmergencyResponders';
import OrganizationEmergencyResponseTeam from './OrganizationEmergencyResponders';
import { Routes } from '@/enums/Routes';
import {
  GroupEmergencyContactsOnAzure,
  OrgEmergencyContactsOnAzure,
} from '../../../../generated-client/models';

interface EmergencyResponseRouteProps {
  getContactsForGroup: (
    groupId: string,
  ) => GroupEmergencyContactsOnAzure | undefined;
  updateGroupContacts: (updatedContacts: GroupEmergencyContactsOnAzure) => void;
  getOrgEmergencyContacts: () => OrgEmergencyContactsOnAzure | null;
  updateOrgEmergencyContacts: (
    updatedContacts: OrgEmergencyContactsOnAzure,
  ) => void;
}

const EmergencyResponseRoute = ({
  getContactsForGroup,
  updateGroupContacts,
  getOrgEmergencyContacts,
  updateOrgEmergencyContacts,
}: EmergencyResponseRouteProps) => {
  return (
    <Switch>
      <Route
        path={`${Routes.EMERGENCY_RESPONDER_MANAGEMENT}/organization`}
        exact
      >
        <OrganizationEmergencyResponseTeam
          getOrgEmergencyContacts={getOrgEmergencyContacts}
          updateOrgEmergencyContacts={updateOrgEmergencyContacts}
        />
      </Route>
      <Route path={`${Routes.EMERGENCY_RESPONDER_MANAGEMENT}/:groupId`} exact>
        <GroupEmergencyResponseTeam
          getContactsForGroup={getContactsForGroup}
          updateGroupContacts={updateGroupContacts}
        />
      </Route>
    </Switch>
  );
};

export default EmergencyResponseRoute;
